<template>
	<div class="encoding-container uk-width-1-1" :id="id">
		<div
			class="encoding-background uk-ratio"
			:class="{ complete: encodingComplete }"
		>
			<img
			  v-show="thumbnail"
			  :src="encodingComplete
				? 'https://placehold.co/800x450/adfe39/222222?text=video%20is%20done%20encoding,%20refresh%20the%20page'
				: thumbnail"
			  style="max-height: 700px; width: auto; object-fit: contain;" />
			<div class="uk-position-center uk-text-center">
				<span
					class="encoding-status"
					v-show="percentage < 100 && !encodingComplete"
				>
					<br /><br /><br /><br />
					{{ percentage }}%
				</span>
			</div>
		</div>
		<div class="uk-margin-top">
			<span v-show="!encodingComplete">
				Video wordt omgezet, dit kan even duren. Progressie: {{
				percentage }}%
			</span>
			<!--<span v-show="encodingComplete">
				<i class="fas fa-check fa-4x color-green"></i><br />
				Encoding done, refresh de pagina om het resultaat te bekijken.
			</span>-->
			<span v-show="encodingError" class="color-red"
				>{{ encodingError }}</span
			>
		</div>
		<progress
			v-show="!encodingComplete"
			class="encoding-progress-bar uk-progress"
			:value="percentage"
			max="100"
		></progress>
	</div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
	id: String,
	progressUrl: String,
	thumbnail: String,
	pollInterval: { type: Number, default: 2000 }, // 2s polling
	timeoutMinutes: { type: Number, default: 30 }  // safety net
  },
  data() {
	return {
	  percentage: 0,
	  timer: null,
	  encodingComplete: false,
	  encodingError: '',
	  startTime: null,
	}
  },
  mounted() {
	this.startPolling();
	this.background = 'https://placehold.co/800x450/adfe39/222222?text=video%20is%20done%20encoding,%20refresh%20the%20page';
  },
  beforeUnmount() {
	this.stopPolling();
  },
  methods: {
	startPolling() {
	  this.startTime = Date.now();
	  this.timer = setInterval(this.checkProgress, this.pollInterval);
	  this.checkProgress(); // run immediately once
	},
	stopPolling() {
	  if (this.timer) {
		clearInterval(this.timer);
		this.timer = null;
	  }
	},
	checkProgress() {
	  if (!this.progressUrl) return;

	  // stop after timeout
	  const elapsed = (Date.now() - this.startTime) / 1000 / 60;
	  if (elapsed > this.timeoutMinutes) {
		this.encodingError = 'Encoding timeout exceeded.';
		this.stopPolling();
		return;
	  }

	  axios.get(this.progressUrl)
		.then(response => {
		  const data = response.data;

		  // case: backend returns empty -> progress file gone -> assume done
		  if (!data || Object.keys(data).length === 0) {
			this.percentage = 100;
			this.encodingComplete = true;
			
			this.stopPolling();
			return;
		  }

		  if (data.success === false) {
			this.encodingError = data.message || 'Encoding error';
			this.stopPolling();
			return;
		  }

		  if (data.progress !== undefined && data.progress !== 'unknown') {
			this.percentage = Math.min(data.progress, 100);

			if (this.percentage >= 100) {
			  this.encodingComplete = true;
			  this.stopPolling();
			}
		  } else if (data.progress === 'unknown') {
			// e.g. GIF input: just show "encoding"
			this.percentage = 0;
		  }
		})
		.catch(error => {
		  this.encodingError = error.message || 'Request failed';
		  this.stopPolling();
		});
	}
  }
}
</script>
